import React from 'react';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { Button } from '../features/ui/button';
import { AlertOctagon } from 'lucide-react';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();


  return (
    <DashboardLayout>
      <div className="flex items-center justify-center h-[calc(100vh-80px)] px-4">
        <div className="bg-card shadow-xl rounded-2xl p-10 max-w-lg w-full text-center animate-fade-in border border-border">
          <div className="flex items-center justify-center mb-6">
            <AlertOctagon className="w-14 h-14 text-destructive" />
          </div>
          <h1 className="text-3xl font-bold text-foreground mb-2">
            403 – Unauthorized Access
          </h1>
          <p className="text-muted-foreground mb-6">
            You don’t have permission to view this page. Please contact your admin if you think this is a mistake.
          </p>
          <Button onClick={() => navigate('/overview')} className="w-full">
            Back to Dashboard
          </Button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Unauthorized;
